// @flow @jsx h

import bem from 'bem'
import { h } from 'preact'
import style from './index.css'

import type { Bio } from './types'

type Props = Bio & { viewport: any }

function CharactedPresentationSection (props: Props) {
  const { viewport } = props

  const inlineStyle = {}

  if (viewport.height > -1) {
    inlineStyle.paddingBottom = `${viewport.height * 0.9}px`
  }

  return (
    <div className={style.characterSlideshow__section} style={inlineStyle}>
      <div className={bem(style.characterSlideshow__card, props.align)}>
        <div className={style.characterSlideshow__cardHeader}>
          <div
            className={style.characterSlideshow__description}
            dangerouslySetInnerHTML={{ __html: props.description }}
          />
          <h2
            className={style.characterSlideshow__title}
            dangerouslySetInnerHTML={{ __html: props.title }}
          />
        </div>

        {props.content && (
          <div className={style.characterSlideshow__content}>
            {props.content.map((item, idx) => {
              switch (item.type) {
                case 'text':
                  return (
                    <p
                      key={String(idx)}
                      dangerouslySetInnerHTML={{ __html: item.value }}
                    />
                  )
                default:
                  return <div />
              }
            })}
          </div>
        )}
      </div>
    </div>
  )
}

export default CharactedPresentationSection



// WEBPACK FOOTER //
// ./src/v1/components/Article/Content/CharacterPresentation/Section.js